import { createReducer, on } from '@ngrx/store';

import { TimetableStatus } from '../../interfaces/index';
import { StatusState } from '../../interfaces/store.interface';
import { StatusActions } from '../actions';

export const initialState: StatusState = {
  status: TimetableStatus.INITIAL,
  error: null,
};

const statusReducer = createReducer(
  initialState,
  on(StatusActions.setStatus, (state, { status }) => ({
    ...state,
    status,
  })),
  on(StatusActions.setError, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function reducer(state: StatusState, action: StatusActions.StatusActionsUnion): StatusState {
  return statusReducer(state, action);
}
